import { Lock, Wrench } from "lucide-react";

export default function SetupHelperBadge({ helper }) {
  if (!helper) return null;
  const { earned, sites } = helper;
  return (
    <div className="mt-4 flex items-center gap-3 border-t border-slate-100 pt-4" data-testid="setup-helper-badge" data-earned={earned ? "true" : "false"}>
      <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full p-[3px] sm:h-14 sm:w-14 ${earned ? "bg-gradient-to-br from-lime-300 to-emerald-600 shadow-md" : "bg-slate-200"}`}>
        <div className={`flex h-full w-full items-center justify-center rounded-full ${earned ? "bg-white text-emerald-700" : "bg-slate-50 text-slate-400"}`}>
          {earned ? <Wrench className="h-5 w-5" /> : <Lock className="h-4 w-4" />}
        </div>
      </div>
      <div className="min-w-0">
        <p className={`text-sm font-semibold ${earned ? "text-slate-900" : "text-slate-400"}`}>Setup helper</p>
        <p className="break-words text-[11px] leading-snug text-slate-500" data-testid="setup-helper-sites">
          {earned
            ? `Your shared setup${sites.length === 1 ? " is" : "s are"} live for every seller: ${sites.join(", ")}`
            : "Share your taught boxes for a site from the Chrome extension. Once approved, you earn this badge and a free week."}
        </p>
      </div>
    </div>
  );
}
